import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../types/product.js';
import { isSubscriptionPurchase } from '../../../../types/typeguards.js';
import { DeliveryIntervalSelect } from './DeliveryIntervalSelect.js';
import { useDeliveryIntervalOptions } from './use-delivery-interval-options.js';

const DeliveryIntervalSelectContainer = ({ className , hasError , deliveryInterval , onIntervalSelection  })=>{
    const { deliveryIntervalOptionsFallback , selectedPurchaseType , activeVariant  } = useProductData();
    let availableSubscriptionIntervals;
    if ('availableSubscriptionIntervals' in activeVariant) {
        availableSubscriptionIntervals = activeVariant.availableSubscriptionIntervals;
    }
    const { deliveryIntervalOptions , selectedInterval  } = useDeliveryIntervalOptions({
        deliveryInterval,
        deliveryIntervalOptionsFallback,
        availableSubscriptionIntervals
    });
    if (!isSubscriptionPurchase(selectedPurchaseType)) {
        return null;
    }
    if (!deliveryIntervalOptions) {
        console.error(`No delivery interval options have been set for sku: '${activeVariant.sku}' and default intervals: '${deliveryIntervalOptionsFallback}'`);
        return null;
    }
    return /*#__PURE__*/ React.createElement(DeliveryIntervalSelect, {
        className: className,
        hasError: hasError,
        selectedInterval: selectedInterval,
        deliveryIntervalOptions: deliveryIntervalOptions,
        onIntervalSelection: onIntervalSelection
    });
};

export { DeliveryIntervalSelectContainer };
//# sourceMappingURL=DeliveryIntervalSelectContainer.js.map
